export const maxGuesses = 6;
